import { createFileRoute } from "@tanstack/react-router";
import { cityServiceHead } from "../lib/route-head";
import { CityServicePage } from "../components/city-service-page";
import { getCityService } from "../data/city-services";


export const Route = createFileRoute("/house-washing-clifton-park-ny")({
  loader: async () => {
    const c = (await import("../data/city-services")).getCityService("house-washing-clifton-park-ny")!;
    return { meta: c.meta, heroImage: c.heroImage, service: c.service, city: c.city, faqs: c.faqs };
  },
  head: ({ loaderData }) => cityServiceHead("house-washing-clifton-park-ny", "house-washing", loaderData),
  component: RouteComponent,
});

function RouteComponent() {
  return <CityServicePage content={getCityService("house-washing-clifton-park-ny")!} />;
}
